import { axiosObject } from "../accessServiceConfig";

export function createNewUser(email: any, password: string, full_name: string) {
  return new Promise((resolve, reject) => {
    let uri = "/loco/resource/admin-users/_create";

    let payload: any = {
      apiConfig: {
        includeRelations: ["attributes"],
      },
      type: "email",
      value: email?.toLowerCase(),
      password: password,
      profile: {
        bio: {
          full_name: full_name,
        },
      },
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function updateBankerUser(data: any, full_name: string) {
  return new Promise((resolve, reject) => {
    let uri = "/loco/resource/admin-users/_patch";
    data.profile.bio["full_name"] = full_name;
    axiosObject
      .post(uri, data)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function findUserByEmail(email: any) {
  return new Promise((resolve, reject) => {
    let uri = "/loco/resource/admin-users/_read";

    let payload: any = {
      sortBy: [{ attribute: "created_at", order: "desc" }],
      limitBy: {
        per_page: 1,
        page: 1,
      },
      apiConfig: {
        includeRelations: ["attributes"],
      },
      filterBy: [{ attribute: "attribute_value", value: email?.toLowerCase() }],
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function findUserByUuid(userUuid: any) {
  return new Promise((resolve, reject) => {
    let uri = "/loco/resource/admin-users/_read";

    let payload: any = {
      sortBy: [{ attribute: "created_at", order: "desc" }],
      limitBy: {
        per_page: 1,
        page: 1,
      },
      apiConfig: {
        includeRelations: ["attributes"],
      },
      filterBy: [{ attribute: "uuid", op: "eq", value: userUuid }],
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function createBranchTeam(
  branchUuid: any,
  bankData: any,
  branchName: any
) {
  if (branchUuid === undefined) {
    return {};
  }

  return new Promise((resolve, reject) => {
    // console.log("params", params);
    const name = `${branchUuid}`;

    let uri = "/loco/resource/admin-teams/_create";

    let payload: any = {
      tenant: "bank-branch",
      name: name,
      slug: name,
      meta: {
        name: name,
        branchUuid: branchUuid,
        branchName: branchName,
        bank: bankData,
        bashboardUrl: `https://${bankData.short_code}.${process.env.NEXT_PUBLIC_DASHBOARD_DOMAIN}`,
      },
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getBranchTeam(branchUuid: any) {
  if (branchUuid === undefined) {
    return { data: [] };
  }
  return new Promise((resolve, reject) => {
    // console.log("params", params);
    const name = `${branchUuid}`;

    let uri = "/loco/resource/admin-teams/_read";

    let payload: any = {
      filterBy: [
        {
          attribute: "name",
          op: "eq",
          value: name,
        },
      ],
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getMemberByUuid(teamUuid: any, memberUuid: any) {
  if (teamUuid === undefined) {
    return {
      data: [],
      meta: {
        total: 0,
      },
    };
  }

  return new Promise((resolve, reject) => {
    console.log("teamUuid", teamUuid);

    let uri = "/loco/resource/admin-team-members/_read";

    let payload: any = {};
    payload["apiConfig"] = {};
    payload["apiConfig"]["includeRelations"] = ["user"];
    payload["filterBy"] = [];

    payload["filterBy"].push({
      attribute: "team_uuid",
      op: "eq",
      value: teamUuid,
    });

    payload["filterBy"].push({
      attribute: "uuid",
      op: "eq",
      value: memberUuid,
    });

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function updateMemberPermissionsByUuid(
  memberUuid: any,
  permissions: any
) {
  return new Promise((resolve, reject) => {
    let uri = "/loco/resource/admin-team-members/_patch";

    let payload: any = {
      uuid: memberUuid,
      permissions: permissions,
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getMembersOfATeam(params: any, teamUuid: any) {
  if (teamUuid === undefined) {
    return {
      data: [],
      meta: {
        total: 0,
      },
    };
  }

  return new Promise((resolve, reject) => {
    console.log("teamUuid", teamUuid);

    let uri = "/loco/resource/admin-team-members/_read";

    let payload: any = {};
    payload["apiConfig"] = {};
    payload["apiConfig"]["includeRelations"] = ["user", "attributes"];

    payload["limitBy"] = {};
    payload["limitBy"]["page"] = params.page;
    payload["limitBy"]["per_page"] = params.per_page;
    payload["filterBy"] = [];

    payload["filterBy"].push({
      attribute: "team_uuid",
      op: "eq",
      value: teamUuid,
    });

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function addBranchTeamMember(
  teamUuid: any,
  userUuid: any,
  permissions: any
) {
  return new Promise((resolve, reject) => {
    // console.log("params", params);

    let uri = `/loco/resource/admin-team-members/_create`;

    let payload: any = {
      team_uuid: teamUuid,
      user_uuid: userUuid,
      status: "approved",
      permissions: permissions,
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function removeBranchTeamMember(memberUuid: any) {
  return new Promise((resolve, reject) => {
    // console.log("params", params);

    let uri = `/loco/resource/admin-team-members/_delete`;

    let payload: any = {
      filterBy: [
        {
          attribute: "uuid",
          op: "eq",
          value: memberUuid,
        },
      ],
    };
    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function updateBranchTeam(
  branchUuid: any,
  bankData: any,
  teamUuid: any,
  branchName: any
) {
  if (branchUuid === undefined) {
    return {};
  }

  return new Promise((resolve, reject) => {
    const name = `${branchUuid}`;

    let uri = "/loco/resource/admin-teams/_patch";

    let payload: any = {
      tenant: "bank-branch",
      name: name,
      slug: name,
      uuid: teamUuid,
      meta: {
        name: name,
        branchUuid: branchUuid,
        branchName: branchName,
        bank: bankData,
        bashboardUrl: `https://${bankData.short_code}.${process.env.NEXT_PUBLIC_DASHBOARD_DOMAIN}`,
      },
    };

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export function getAllMembersOfATeam(teamUuid: any) {
  if (teamUuid === undefined) {
    return {
      data: [],
      meta: {
        total: 0,
      },
    };
  }

  return new Promise((resolve, reject) => {
    console.log("teamUuid", teamUuid);

    let uri = "/loco/resource/team-members/_read";

    let payload: any = {};
    payload["apiConfig"] = {};
    payload["apiConfig"]["includeRelations"] = ["user", "attributes"];

    payload["limitBy"] = {};
    payload["limitBy"]["page"] = 1;
    payload["limitBy"]["per_page"] = 999;
    payload["filterBy"] = [];

    payload["filterBy"].push({
      attribute: "team_uuid",
      op: "eq",
      value: teamUuid,
    });

    axiosObject
      .post(uri, payload)
      .then(async (response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}
